module.exports = __webpack_public_path__ + "fonts/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSKmu0SC55K5gw.woff2";